export const getRange = (name, value) => {
  let data = {
    [`${name}[gte]`]: value[0],
    [`${name}[lte]`]: value[1],
  }
  if (value[2]) {
    data.priceType = value[2]
  }
  return data
}